/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Err_Quantity_RequiredInputs */

const vi_form_err_quantity_required = /** @type {(inputs: Form_Err_Quantity_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập số lượng`)
};

/**

* @param {Form_Err_Quantity_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const form_err_quantity_required = /** @type {((inputs?: Form_Err_Quantity_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Err_Quantity_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_form_err_quantity_required(inputs)
});